import classNames from 'classnames';
import { FormattedNumber } from 'react-intl';
import { useQuoteColor } from 'routes/essential-workspace/hooks/use-quote';
import { useQuotePriceInfo } from 'routes/essential-workspace/hooks/use-quote-price-info';
import { FormIdProps } from 'shared/props';

export function Price({ formId }: FormIdProps) {
  const { textColor } = useQuoteColor(formId);
  const { format, price, isStrikethrough } = useQuotePriceInfo(formId);

  return (
    price !== undefined && (
      <p
        className={classNames('monospace-numbers fs-2 fw-medium lh-1', textColor, {
          'text-decoration-line-through': isStrikethrough,
        })}
      >
        {<FormattedNumber value={price} maximumFractionDigits={4} style={format} />}
      </p>
    )
  );
}
